import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';

function Transition(props) {
  return <Slide direction="up" { ...props } />;
}

const ConfirmationDialog = (
  {
    closeDialog,
    message,
    messages,
    negativeAction,
    negativeText,
    open,
    positiveAction,
    positiveText,
    title,
  },
) => (
  <div>
    <Dialog
      open={ open }
      TransitionComponent={ Transition }
      keepMounted
      onClose={ closeDialog }
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        { title }
      </DialogTitle>
      <DialogContent>
        {
          messages.length > 0
          && (
            <DialogContentText id="alert-dialog-slide-description">
              <span style={ { paddingLeft: 10 } }>
                { messages.map(currentMessage => (
                  <span key={ currentMessage } style={ { display: 'block', paddingLeft: 10 } }>
                    &#8226;
                    { currentMessage }
                  </span>
                )) }
              </span>
            </DialogContentText>
          )
        }

        {
          message !== ''
          && (
            <DialogContentText id="alert-dialog-slide-description">
              { message }
            </DialogContentText>
          )
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={ negativeAction } color="primary">
          { negativeText }
        </Button>
        {
          positiveText
          && (
            <Button onClick={ positiveAction } color="primary">
              { positiveText }
            </Button>
          )
        }
      </DialogActions>
    </Dialog>
  </div>
);

ConfirmationDialog.defaultProps = {
  closeDialog: () => {},
  message: {},
  messages: [],
  positiveAction: () => {},
  positiveText: '',
};

ConfirmationDialog.propTypes = {
  closeDialog: PropTypes.func,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  messages: PropTypes.array,
  negativeAction: PropTypes.func.isRequired,
  negativeText: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  positiveAction: PropTypes.func,
  positiveText: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default ConfirmationDialog;
